import { createColumnBuilders, DataTableColumn } from '../../../shared/components/DataTable'
import { getAcronym } from '../../../shared/utils/acronym'
import { toListLabel } from '../../../shared/utils/displayValue'
import { VALUE_MESSAGE_STATUSES } from './ValueMessageTable.constants'
import { ValueMessageColumnId, ValueMessageDisplayNames, ValueMessageRow } from './ValueMessageTable.types'

type ValueMessageColumn = DataTableColumn<ValueMessageRow, ValueMessageColumnId>

const { text, date, count, yesNo } = createColumnBuilders<ValueMessageRow, ValueMessageColumnId>()

const getStatusSortOrder = (row: ValueMessageRow) => {
    const index = VALUE_MESSAGE_STATUSES.findIndex((status) => status.id === row.status)

    return index === -1 ? VALUE_MESSAGE_STATUSES.length : index
}

export const getValueMessageColumns = ({
    valueNarrative,
    evidence,
    evidenceGaps,
    activities,
    strategicImperatives,
    tpp,
}: ValueMessageDisplayNames): ValueMessageColumn[] => [
    text('name', 'Title', (row) => row.name, { width: 400 }),
    { id: 'status', label: 'Status', width: 190, getSortValue: getStatusSortOrder },
    text('category', 'Category', (row) => row.categoryName, { width: 150 }),
    text('narrative', valueNarrative, (row) => row.narrativeName, { width: 320 }),
    text('priority', 'Priority', (row) => row.priority),
    text('description', 'Description', (row) => row.description, { width: 250 }),
    text('audiences', 'Audiences', (row) => toListLabel(row.audienceNames), { width: 275 }),
    text('internalStakeholders', 'Internal Stakeholders', (row) => toListLabel(row.internalStakeholderNames), {
        width: 250,
    }),
    text('localMarkets', 'Local Markets', (row) => toListLabel(row.localMarkets)),
    yesNo('isCountrySpecific', 'Country Specific', (row) => !!row.isCountrySpecific),
    yesNo('isInternal', 'Internal', (row) => !!row.isInternal),
    count('linkedEvidenceCount', `Linked ${getAcronym(evidence)}`, (row) => row.linkedEvidenceCount, {
        tooltip: `Linked ${evidence}`,
    }),
    count('primaryEvidenceCount', `Primary ${evidence}`, (row) => row.primaryEvidenceCount),
    count('keyEvidenceStatementCount', 'Linked KES', (row) => row.keyEvidenceStatementCount, {
        tooltip: 'Linked Key Evidence Statements',
    }),
    count('evidenceGapCount', evidenceGaps, (row) => row.evidenceGapCount),
    count('linkedActivityCount', `Linked ${getAcronym(activities)}`, (row) => row.linkedActivityCount, {
        tooltip: `Linked ${activities}`,
    }),
    count(
        'linkedStrategicImperativeCount',
        `Linked ${getAcronym(strategicImperatives)}`,
        (row) => row.linkedStrategicImperativeCount,
        { tooltip: `Linked ${strategicImperatives}` }
    ),
    count('linkedTppCellCount', `Linked ${getAcronym(tpp)} Cells`, (row) => row.linkedTppCellCount),
    date('createdAt', 'Created', (row) => row.createdAtValue),
    date('updatedAt', 'Updated', (row) => row.updatedAtValue),
]
